var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookFill = function SvgFacebookFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.3 13.35h2.25l.9-3.6H14.3v-1.8c0-.927 0-1.8 1.8-1.8h1.35V3.126A25 25 0 0 0 14.879 3C12.435 3 10.7 4.491 10.7 7.23v2.52H8v3.6h2.7V21h3.6z"
  })));
};
export default SvgFacebookFill;